import { useLocation } from 'react-router-dom';

import { useMemo } from 'react';
import { QUERY_SHARE_TEAM_ID, QUERY_SHARE_ITEM_ID } from '../config';
import { teamsModel } from '../../../features/teams';
import { useSelector } from 'react-redux';

export const useShareParams = () => {
  const teams = useSelector(teamsModel.selectors.selectTeams);
  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const { search } = useLocation();

  const params = useMemo(() => {
    return {
      id: new URLSearchParams(search).get(QUERY_SHARE_ITEM_ID),
      teamId: new URLSearchParams(search).get(QUERY_SHARE_TEAM_ID),
    };
  }, [search]);

  const secondTeam = useMemo(() => {
    if (params.teamId === null) {
      return null;
    }

    const team = teams.find((team) => team.id === Number(params.teamId));

    return team && currentTeam.id !== Number(params.teamId)
      ? { name: team.name }
      : null;
  }, [params, currentTeam, teams]);

  return { params, secondTeam };
};
